module.exports = __webpack_public_path__ + "media/images/icons/physical_computing_kits-49d84a679ac4850b5f0cbbd89ca1d6ef.svg";